<template>
  <div class="containerMessage" :style="{'background-color': 'none', 'width':'100% !important','max-width':'100%' }">
    <ul class="ulMessageMenu">
      <li class="liMessageMenu" :style="{'height': '120px !important'}"
        v-bind:class="optionClicked ? 'changeCursor ' + 'notselected' : 'selected'">
        <div class="row">
          <div class="column">
            <a class="aSurveyMessage" v-on:click="sendMessage(getObjectMenu(message.message)[0].option)"
              v-bind:class="optionClicked ? 'changeCursor' : ''" >
              <div class="faces centrado" :style="{'background-image' : 'url(' + avatar5 + ')', 'top':'0px'}"></div>
              <div class="centrado" :style="{'font-size':'9px!important', 'top':'50px'}">{{ getObjectMenu(message.message)[0].optionName[0] }}</div>
            </a>
          </div>
          <div class="column">
            <a class="aSurveyMessage" v-on:click="sendMessage(getObjectMenu(message.message)[1].option)"
              v-bind:class="optionClicked ? 'changeCursor' : ''">
              <div  class="faces centrado" :style="{'background-image' : 'url(' + avatar4 + ')', 'top':'0px'}"></div>
              <div class="centrado" :style="{'font-size':'9px!important', 'top':'50px'}">{{ getObjectMenu(message.message)[1].optionName[0] }}</div>
            </a>
          </div>
          <div class="column">
            <a class="aSurveyMessage" v-on:click="sendMessage(getObjectMenu(message.message)[2].option)"
              v-bind:class="optionClicked ? 'changeCursor' : ''">
              <div  class="faces centrado" :style="{'background-image' : 'url(' + avatar3 + ')', 'top':'0px'}"></div>
              <div  class="centrado" :style="{'font-size':'9px!important', 'top':'50px'}"> {{ getObjectMenu(message.message)[2].optionName[0] }} </div>
            </a>
          </div> 
          <div class="column">
            <a class="aSurveyMessage" v-on:click="sendMessage(getObjectMenu(message.message)[3].option)"
              v-bind:class="optionClicked ? 'changeCursor' : ''" >
              <div  class="faces centrado" :style="{'background-image' : 'url(' + avatar2 + ')', 'top':'0px'}"></div>
              <div class="centrado" :style="{'font-size':'9px!important', 'text-align':'center !important', 'top':'50px'}"> {{ getObjectMenu(message.message)[3].optionName[0] }} </div>
            </a>
          </div>
          <div class="column">
            <a class="aSurveyMessage" v-on:click="sendMessage(getObjectMenu(message.message)[4].option)"
              v-bind:class="optionClicked ? 'changeCursor' : ''"  > 
              <div class="faces centrado" :style="{'background-image' : 'url(' + avatar1 + ')', 'top':'0px'}"></div>
              <div class="centrado" :style="{'font-size':'9px!important', 'top':'50px'}"> {{ getObjectMenu(message.message)[4].optionName[0] }} </div>
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template> 

<style>

.liMessageMenu {
  margin-bottom: 10px;
  padding: 8px;
  padding-left: 17px;
  border-radius: 50px;
  border: 2px solid #fff;
  background: white;
  min-width: 50% !important;
  padding: 8px 10px;
  
  font-weight: 400;
  word-wrap: break-word;
  border-radius: 20px;
  position: relative;
}

.liMessageMenu:hover {
  background: #e1e1e182;
  cursor: pointer;
}

.liMessageMenu a {
  display: inline-block;
}
.ulMessageMenu {
  padding-left: 0px;
  list-style:none;
}
.notselected {
  background: #f1efef82;
  opacity: 0.3;
}

.selected {
  background: #fff !important;
}

.changeCursor {
  cursor: default !important;
}

.option-number {
  display: inline-block;
  position: absolute;
}

.aSurveyMessage{
  color:#000000 !important; 
  text-align: center !important;
  width: 80px !important;
  position: relative;
}

.faces{
   height:35px !important;
   width: 35px !important;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 20% !important; 
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.centrado {
   position: absolute;
   transform:translate(-50%,-0%);
   -webkit-transform:translate(-50%,-0%);
}


</style>
<script>
import { invertColor } from "@/assets/utils";
import Avatar1 from "../assets/surveyEmoji1.svg";
import Avatar2 from "../assets/surveyEmoji2.svg";
import Avatar3 from "../assets/surveyEmoji3.svg";
import Avatar4 from "../assets/surveyEmoji4.svg";
import Avatar5 from "../assets/surveyEmoji5.svg";

export default {
  props: { message: Object },
  name: "messageSurvey",
  components: {},
  computed: {},
  methods: {
    disableMenuMessage(message) {
      this.message.optionClicked = message;
      this.optionClicked = message;
    },
    sendMessage(message) {
      if (!this.message.optionClicked) {
        this.message.optionClicked = message;
        this.optionClicked = message;
        this.$eventManagerMenu.sendMessage(message);
        this.$store.commit("updateMessage", this.message);
      }
    },
    getObjectMenu(message) {
      let m = message.substring(8);
      
      let msg = m.split(/(\d+ *\- *)/g);
      msg = msg.filter(item => item);
      var arr = [];
      for (var i = 0; i < msg.length; i++) {
        if (msg[i].match(/(\d+ *\- *)/g)) {
          arr.push(msg[i].trim());
        } else {
          let e = arr.pop();
          e = e + msg[i].trim();
          arr.push(e);
        } 
      }

        return arr.map(m => {
        let item = {};
        item.option = parseInt(m.split(/\-/)[0].replace("-", "").trim());
        item.optionName = m.split(/\-/)[1];
        item.optionName = item.optionName.split(String.fromCharCode(10));
        item.optionName = item.optionName.filter(item => item);

        item.optionName[0] = item.optionName[0];
        
        return item;
      });
    }, 
    invertColor
  },
  created() {
    this.optionClicked = this.message.optionClicked;
  },
  data() {
    return {
      optionClicked: false,
      avatar1:Avatar1,
      avatar2:Avatar2,
      avatar3:Avatar3,
      avatar4:Avatar4,
      avatar5:Avatar5,
    };
  }
};
</script> 

